import { render, staticRenderFns } from "./tabbar3.7.vue?vue&type=template&id=c57b453e&scoped=true"
import script from "./tabbar3.7.vue?vue&type=script&lang=js"
export * from "./tabbar3.7.vue?vue&type=script&lang=js"
import style0 from "./tabbar3.7.vue?vue&type=style&index=0&id=c57b453e&prod&lang=css"
import style1 from "./tabbar3.7.vue?vue&type=style&index=1&id=c57b453e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57b453e",
  null
  
)

export default component.exports